export default {
  classic: 'material-icons',
  prefix: 'material-icons prefix',
  right: 'material-icons right',
  left: 'material-icons left',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/icons.js